import React from 'react';

import { Group, Paper, Stack, Text } from '@mantine/core';
import { SelfBookingAppointmentType } from 'types/generated';

interface AppointmentTypeCardProps {
  appointmentType: SelfBookingAppointmentType;
  onSelect?: (appointmentTypeId: string) => void;
}

const AppointmentTypeCard = ({ appointmentType, onSelect }: AppointmentTypeCardProps): JSX.Element => {
  const handleClick = (e: React.MouseEvent): void => {
    if (onSelect) {
      e.preventDefault();
      onSelect(appointmentType.appointmentTypeId);
    }
  };

  return (
    <Paper
      component={onSelect ? 'div' : 'a'}
      href={!onSelect ? `/appointment-types/${appointmentType.appointmentTypeId}/self-booking` : undefined}
      onClick={onSelect ? handleClick : undefined}
      shadow='xs'
      radius='lg'
      p='xl'
      sx={{ cursor: 'pointer' }}
    >
      <Stack spacing='0'>
        <Text size='xl' weight={700} lineClamp={1}>
          {appointmentType.name}
        </Text>

        <Group spacing='md'>
          <Text weight={600} color='dimmed'>
            {appointmentType.duration} Minutes
          </Text>

          {appointmentType.location && (
            <Text weight={600} color='dimmed' lineClamp={1}>
              | {appointmentType.location.name}
            </Text>
          )}
        </Group>
      </Stack>
    </Paper>
  );
};

export default AppointmentTypeCard;
